<template>
	<v-row
		class="fill-height"
		align-content="center"
		justify="center"
	>
		<v-col
			class="text-subtitle-1 text-center"
			cols="12"
		>
			{{ text }}
		</v-col>
		<v-col cols="10">
			<v-progress-linear
				:color="color"
				indeterminate
				rounded
				height="6"
			></v-progress-linear>
		</v-col>
	</v-row>
</template>
<script>
export default {
	name: 'ProgressLinear',
	props: {
		text: {
			type: String,
			default: 'Getting your data'
		},
		color: {
			type: String,
			default: 'rgba(0, 0, 0, 0.4)'
		}
	}
}
</script>